export const iconFontAwesomeShoppingShop = (
	<i className="fa-solid fa-shop"></i>
);
